<template>
  <b-card title="">
    <h3 class="text-primary font-weight-bold mb-2">รายงานคิวที่จอง</h3>

    <b-row>
      <b-col md="6">
        <h5 class="h4 font-weight-bold">AL Code</h5>
        <b-form-group label="" label-for="IdCode">
          <b-form-input id="IdCode" v-model="formUser.IdCode" placeholder="AL Code" />
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group>
          <h5 class="h4 font-weight-bold">ด่านชายแดน</h5>
          <b-form-select v-model="selectedBorder" :options="options"
            :class="{ 'is-invalid': showError && !selectedBorder }" />
          <div class="invalid-feedback">กรุณาเลือกด่านชายแดน</div>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group>
          <h5 class="h4 font-weight-bold">เลือกวันที่เริ่มต้นลงทะเบียน</h5>
          <flat-pickr v-model="startDate" class="form-control" :config="DateConfig" />
        </b-form-group>
      </b-col>

      <b-col md="6">
        <b-form-group>
          <h5 class="h4 font-weight-bold">เลือกวันที่สิ้นสุดลงทะเบียน</h5>
          <flat-pickr v-model="endDate" class="form-control" :config="DateConfig" />
        </b-form-group>
      </b-col>
      <b-col md="6"></b-col>
      <b-col md="6"></b-col>
      <!-- <b-col md="6">
        <b-form-group>
          <h5 class="font-weight-bold">วันที่เข้าประเทศไทย</h5>
          <flat-pickr
            v-model="in_dateDefault"
            class="form-control"
            :class="{ 'is-invalid': showError && !in_dateDefault }"
            :config="{ dateFormat: 'd-m-Y' }"
          />
          <div class="invalid-feedback">วันที่เข้าประเทศไทย</div>
        </b-form-group>
      </b-col> -->
      <b-col md="6">
        <br />
        <!-- <b-button variant="primary" @click.prevent="Getdata"> ค้นหา </b-button> -->
        <b-button variant="primary" type="submit" @click.prevent="Getdata" :disabled="isLoading">
          <template v-if="isLoading">
            <b-spinner small type="grow" class="mr-1" />
            กำลังค้นหา...
          </template>
          <template v-else>
            ค้นหา
          </template>
        </b-button>
      </b-col>
      <br />
      <b-col md="6"></b-col>
      <b-col md="6">
        <br />
        <h3 class="text-primary font-weight-bold mb-2">
          ตารางแสดงรายการคิวที่จอง
        </h3>
      </b-col>
      <b-col md="6"></b-col>
      <b-col md="12">
        <div class="mt-4 text-right">

          <b-button v-if="hasSelected" variant="success" @click="UpdateStatus">
            อัพเดทสถานะสร้างบัตรสำเร็จ
          </b-button>
        </div>
      </b-col>



      <b-col md="4" sm="4" class="my-1 ">
        <b-form-group class="mb-0">
          <label class="h5 d-inline-block text-sm-left mr-50">จำนวนต่อหน้า</label>
          <b-form-select id="perPageSelect" v-model="perPage" size="sm" :options="pageOptions" class="w-50"
            @change="handleItemsPerPageChange" />

        </b-form-group>
      </b-col>

      <!-- mapAll -->
      <b-col md="4">
        <div v-if="items.length != 0">
          <b-form-group class="mb-0">
            <label class="h5 d-inline-block text-sm-left mr-50">แผนที่ทั้งหมด</label>
            <b-button formtarget="_blank" @click="goMapAll">
              <feather-icon icon="MapIcon" size="14" class="mr-50 cursor-pointer" />
            </b-button>

          </b-form-group>

        </div>
      </b-col>

      <b-col md="4" class="my-1">
        <b-form-group label="ค้นหา" label-cols-sm="3" label-align-sm="right" label-size="sm" label-for="filterInput"
          class="mb-0 h5">
          <b-input-group size="sm">
            <b-form-input id="filterInput" v-model="filter" type="search" placeholder="พิมพ์เพื่อค้นหา" />
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">
                ยกเลิก
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>

    <b-col cols="12">
      <b-table striped hover responsive :current-page="currentPage" :items="items" :fields="fields"
        :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" :filter="filter"
        :filter-included-fields="filterOn" @filtered="onFiltered" :row-class="rowClass" @row-selected="onRowSelected">

        <template #head(select)>
          <span class="text-success te">อัพเดทสร้างบัตรสำเร็จ</span> <b-form-checkbox
            v-model="allSelected"></b-form-checkbox>
        </template>

        <template #cell(select)="row">
          <b-form-checkbox :value="row.item" v-model="selectedRows"></b-form-checkbox>
        </template>

        <template #cell(updatestatus)="data">
          <feather-icon icon="EyeIcon" size="14" class="mr-50 cursor-pointer" @click="openStatusModal(data.item)" />
        </template>
        <!-- map -->
        <template #cell(map)="data">

          <b-link target="_blank" :to="{ name: 'map', params: { latlon: `${data.item.location.latitude},${data.item.location.longitude}` } }
            ">
            <feather-icon icon="MapIcon" size="14" class="mr-50 cursor-pointer" />
          </b-link>
        </template>

        <template #cell(actionEdit)="props">
          <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
            <template #button-content>
              <feather-icon icon="MoreVerticalIcon" size="16" class="text-body align-middle mr-25" />
            </template>
            <b-dropdown-item @click="editItem(props.item)">
              <feather-icon icon="Edit2Icon" class="mr-50" />
              <span>แก้ไข</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
        <template #cell(cardSerialNumber)="data">
          <span :class="{
            'badge badge-warning': !data.item.cardSerialNumber,   // ว่าง -> สีส้ม
            'badge badge-success': data.item.cardSerialNumber     // มีค่า -> สีเขียว
          }">
            {{ data.item.cardSerialNumber || 'รอดำเนินการ' }}
          </span>
        </template>
        <template #cell(processingStatus)="data">
          <div class="d-flex flex-column">
            <!-- {{  data.item.processingStatus }} -->
            <div v-for="(status, index) in parsedStatus(data.item.processingStatus)" :key="index"
              class="d-flex align-items-center mb-1">
              <!-- Step number -->
              <!-- <span class="badge badge-secondary mr-2">{{ index + 1 }}</span> -->

              <!-- ชื่อขั้นตอน -->
              <span class="font-weight-bold mr-2">{{ Object.keys(status)[0] }}:</span>

              <!-- ค่า + สีตามผล -->
              <span :class="['badge', badgeClass(Object.values(status)[0])]">
                {{ Object.values(status)[0] }}
              </span>
            </div>
          </div>
        </template>
        <template #cell(status)="data">
          <span :class="{
            'badge badge-primary': data.item.status === 'confirmed' && data.item.actualExitDate === '',
            'badge badge-success': data.item.status === 'confirmed' && data.item.actualExitDate != ''
          }">
            {{ data.item.status }}
          </span>
        </template>
        <template #cell(actualEntryDate)="data">
          <span :class="{
            'badge badge-success': data.item.actualEntryDate != ''
          }">
            {{ data.item.actualEntryDate }}
          </span>
        </template>
        <template #cell(actualExitDate)="data">
          <span :class="{
            'badge badge-success': data.item.actualExitDate != ''
          }">
            {{ data.item.actualExitDate }}
          </span>
        </template>
        <template #cell(actionimg)="props">
          <b-button variant="outline-primary" size="sm" @click="createImageAndSave(props.item)" title="ดาวน์โหลดรูปภาพ">
            <feather-icon icon="ImageIcon" />
          </b-button>
        </template>
        <!-- 👇 CUSTOM ACTION COLUMN -->
        <template #cell(action)="props">
          <b-button variant="outline-primary" size="sm" @click="handlePrint(props.item)" title="ดาวน์โหลด PDF">
            <feather-icon icon="FileTextIcon" />
          </b-button>
        </template>
      </b-table>
    </b-col>


    <!-- Popup -->
    <b-modal v-model="showModal" title="แก้ไขสถานะ" size="lg" hide-footer>
      <div v-for="(group, gIndex) in statusGroups" :key="gIndex" class="mb-3 p-2 border rounded">
        <!-- หัวหมวด + ปุ่มลบ -->
        <div class="d-flex justify-content-between align-items-center mb-2">
          <h5 class="mb-0">{{ group.category }}</h5>
          <b-button variant="outline-danger" size="sm" @click="removeCategory(gIndex)">
            ลบหมวด
          </b-button>
        </div>

        <!-- ช่องสถานะ -->
        <b-form-group>
          <div v-for="(status, sIndex) in group.statusList" :key="sIndex" class="d-flex mb-2">
            <b-form-input v-model="group.statusList[sIndex]" placeholder="กรอกสถานะ" class="mr-2" />
            <b-button variant="danger" size="sm" @click="removeStatus(gIndex, sIndex)">ลบ</b-button>
          </div>
          <b-button variant="success" size="sm" :disabled="group.statusList.length >= 1" @click="addStatus(gIndex)">+
            เพิ่มสถานะ</b-button>
        </b-form-group>
      </div>

      <!-- เพิ่มหมวดใหม่ -->
      <div class="mt-3">
        <b-input-group>
          <b-form-input v-model="newCategory" placeholder="ชื่อหมวดใหม่ เช่น ตรวจโรค, จ่ายเงิน" />
          <b-input-group-append>
            <b-button variant="primary" @click="addCategory">+ เพิ่มหมวด</b-button>
          </b-input-group-append>
        </b-input-group>
      </div>

      <!-- ปุ่มบันทึก -->
      <div class="mt-4 text-right">
        <!-- <b-button variant="secondary" @click="showModal = false">ปิด</b-button> -->
        <b-button variant="primary" @click="saveStatus">บันทึก</b-button>
      </div>
    </b-modal>

    <!-- Pagination -->
    <b-card v-show="true" class="p-0 mb-1" no-body>
      <b-nav class="navbar d-flex justify-content-between bd-highlight flex-wrap">
        <div>
          Showing {{ (currentPage - 1) * perPage + 1 }} to
          {{ Math.min(currentPage * perPage, totalRows) }}
          of {{ totalRows }} entries
        </div>
        <!-- {{currentPage}} -->
        <div class="bd-highlight">
          <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" @input="handlePageChange"
            class="mb-0" first-text="First" prev-text="Prev" next-text="Next" last-text="Last" align="left"
            hide-goto-end-buttons />
        </div>
      </b-nav>
    </b-card>

    <b-modal id="edit-user-modal" v-model="showEditModal" class="h3 font-weight-bold" title="แก้ไขข้อมูลผู้ลงทะเบียน"
      size="lg" hide-footer>
      <b-form @submit.prevent="saveEdit">
        <b-row>

          <!-- ด่านชายแดน -->
          <b-col md="6">
            <h5 class="h4 font-weight-bold">ด่านชายแดน</h5>
            <b-form-group label="" label-for="border-select">
              <b-form-select id="border-select" v-model="editUser.BorderCheckpoint" :options="options" text-field="text"
                value-field="value" :class="{ 'is-invalid': showError && !editUser.BorderCheckpoint }" />
              <div class="invalid-feedback">กรุณาเลือกด่านชายแดน</div>
            </b-form-group>
          </b-col>

          <!-- แสดงจำนวนคิวที่เหลือ -->
          <b-col md="6">
            <b-card-text class="mt-2 mb-0 font-weight-bold" v-if="editUser.BorderCheckpoint && count_data !== 0">
              <span class="text-primary">
                คิวที่เหลือ:
                <strong>
                  / ด่านชายแดน จังหวัด{{ editUser.BorderCheckpoint }} / {{ count_data }}
                </strong>
                คิว
              </span>
            </b-card-text>
            <b-card-text class="text-danger font-weight-bold" v-else-if="!editUser.registeredExitDate">
              กรุณาเลือกวันที่
            </b-card-text>
          </b-col>

          <!-- วันที่ออกประเทศไทย -->
          <b-col md="6">
            <h5 class="h4 font-weight-bold">วันที่เดินทางออกประเทศไทย</h5>
            <b-form-group label="">
              <flat-pickr v-model="editUser.registeredExitDate" class="form-control"
                :class="{ 'is-invalid': showError && !editUser.registeredExitDate }" :config="outDateConfig" />
              <div class="invalid-feedback">กรุณาเลือกวันที่ออกประเทศไทย</div>
            </b-form-group>
          </b-col>

          <!-- วันที่เข้าประเทศไทย -->
          <b-col md="6">
            <h5 class="h4 font-weight-bold">วันที่เข้าประเทศไทย</h5>
            <b-form-group label="">
              <flat-pickr v-model="editUser.registeredEntryDate" class="form-control"
                :class="{ 'is-invalid': showError && !editUser.registeredEntryDate }"
                :config="{ dateFormat: 'd-m-Y' }" />
              <div class="invalid-feedback">กรุณาเลือกวันที่เข้าประเทศไทย</div>
            </b-form-group>
          </b-col>

          <!-- เลือกรอบ -->
          <b-col md="12">
            <h5 class="h4 font-weight-bold">เลือกรอบ</h5>
            <h5 class="font-weight-bold"></h5>
            <b-form-radio-group v-model="editUser.Round" name="round-selection" class="d-flex flex-wrap">
              <b-form-radio value="รอบเช้า" class="mr-3">รอบเช้า</b-form-radio>
              <b-form-radio value="รอบบ่าย">รอบบ่าย</b-form-radio>
            </b-form-radio-group>
          </b-col>
        </b-row>

        <!-- ปุ่มด้านล่าง -->
        <div class="d-flex justify-content-end mt-3">
          <b-button variant="secondary" @click="showEditModal = false">ยกเลิก</b-button>
          <b-button variant="primary" type="submit" class="ml-2">อัพเดทข้อมูล</b-button>
        </div>
      </b-form>
    </b-modal>
  </b-card>
</template>

<script>
import {
  BTable,
  BAvatar,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
} from "bootstrap-vue";
import { BCard, BCardText } from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import store from "@/store/index";
import API from "@/connect/config";
import axios from "axios";
import { BNav } from "bootstrap-vue";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import QRCode from "qrcode";
import html2canvas from "html2canvas";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

import { togglePasswordVisibility } from "@core/mixins/ui/forms";

import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import flagSrcL from '@/assets/images/icons/1.png';
import flagSrcR from '@/assets/images/icons/2.png';
dayjs.extend(customParseFormat);
import router from '@/router'
export default {
  components: {
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCard,
    BCardText,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BNav,
    flatPickr,
  },
  mixins: [togglePasswordVisibility],

  data() {
    return {
      perPage: 100,
      pageOptions: [25, 50, 100],
      totalPage: 0,
      totalRows: 0,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      isBusy: false,
      items: [],
      filter: null,
      filterOn: [],
      selectedBorder: null, // ✅ ค่า default (ตรงกับ value: null)
      fields: [
        { key: "select", label: "", sortable: false },
        { key: "no", label: "ลำดับที่" },
        { key: "IdCode", label: "เลขพาสปอร์ต/เลขที่ประจำตัว13หลัก" },
        { key: "prefix", label: "คำนำหน้า" },
        { key: "firstname", label: "ชื่อ" },
        { key: "lastname", label: "นามสกุล" },
        { key: "gender", label: "เพศ" },
        { key: "cardSerialNumber", label: "card SerialNumber" },
        { key: "processingStatus", label: "สถานะ" },
        { key: "registeredExitDate", label: "วันที่เดินทางออกประเทศไทย" },
        { key: "registeredEntryDate", label: "วันที่เดินทางเข้าประเทศไทย" },
        { key: "createdAtFormatted", label: "วันที่ลงทะเบียน" },
        { key: "actualExitDate", label: "วันที่ออกจริง" },
        { key: "actualEntryDate", label: "วันที่เข้ามาจริง" },
        { key: "status", label: "สถานะ" },
        { key: "actionimg", label: "ดาวน์โหลดรูปภาพ" }, // ✅ เพิ่มตรงนี้
        // { key: "action", label: "ดาวน์โหลด PDF" }, // ✅ เพิ่มตรงนี้
        { key: "updatestatus", label: "อัพเดทสถานะ" }, // ✅ เพิ่มตรงนี้
        { key: "map", label: "แผนที่" }, // ✅ เพิ่มตรงนี้
        { key: "actionEdit", label: "แก้ไขข้อมูลด่านชายแดน" }, // ✅ เพิ่มตรงนี้


      ],
      in_dateDefault: null, // new Date(), // หรือใช้ null, หรือ new Date() ก็ได้
      out_dateDefault: new Date(), //new Date(), // หรือใช้ null, หรือ new Date() ก็ได้
      showError: false,
      outDateConfig: {
        dateFormat: "d-m-Y",
        // onChange: this.handleOutDateChange.bind(this),
      },
      DateConfig: {
        dateFormat: "Y-m-d", // format ที่ใช้ส่งจริง
        altInput: true,
        altFormat: "d-m-Y",  // format ที่แสดงผล
      },
      options: [],
      startDate: new Date(),
      endDate: new Date(),
      formUser: {
        reqcode: "",
        IdCode: "",
        Issuerdate: '',
        Expireddate: '',
        Birthdate: '',
      },
      showEditModal: false,
      editUser: {},
      count_data: 0,
      showError: false,
      showModal: false,
      selectedItem: null,
      selectedRows: [],

      //  statusGroups: [
      //   { category: "CI", statusList: ["อนุมัติ", "ไม่อนุมัติ", "ยกเลิก"] },
      //   { category: "AS", statusList: ["อนุมัติ", "ไม่อนุมัติ", "ยกเลิก"] }
      // ],
      statusGroups: [],
      newCategory: "",
      isLoading: false,
    };
  },
  computed: {
    // แสดงปุ่มถ้ามีเลือก
    hasSelected() {
      return this.selectedRows.length > 0
    },
    // เช็คว่าเลือกครบทุกแถวหรือยัง
    allSelected: {
      get() {
        return this.selectedRows.length === this.items.length
      },
      set(value) {
        if (value) {
          // เลือกทั้งหมด
          this.selectedRows = [...this.items]
        } else {
          // ยกเลิกทั้งหมด
          this.selectedRows = []
        }
      },
    },

    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },
  },
  created() {
    // this.getDataTable();
  },
  mounted() {

    this.getDataSelectOption();
    // Set the initial number of items
    //this.totalRows = this.items.length;
    if (this.items && this.items.length) {
      console.log(this.items.length);
    } else {
      console.log("ยังไม่มีข้อมูล items");
    }
  },
  methods: {
    goMapAll() {
      // เก็บใน Vuex
      this.$store.commit('addMapAll', this.items.map((el) => {
        console.log(el.location)
        typeof (el.location)
        if (el.location != '') {
          console.log(JSON.stringify(el.location))
          return {
            ...el
          }
        }
      }))

      // เปลี่ยนหน้าไป /mapall
      this.$router.push({ name: 'mapall' })
    },
    onRowSelected(rows) {
      this.selectedRows = rows
      this.allSelected = this.selectedRows.length === this.items.length
    },
    toggleAll() {
      if (this.allSelected) {
        this.selectedRows = [...this.items]
      } else {
        this.selectedRows = []
      }
    },

    parsedStatus(processingStatus) {
      try {
        const parsed = JSON.parse(processingStatus); // แปลง JSON string → array

        if (!Array.isArray(parsed)) return [];

        // แปลงทุก object ใน array ให้กลายเป็น array ของ object แยกขั้นตอน
        return parsed.flatMap(obj =>
          Object.entries(obj).map(([key, value]) => ({ [key]: value }))
        );
      } catch (e) {
        console.error("Error parsing processingStatus:", e);
        return [];
      }
    },
    badgeClass(value) {
      if (["สำเร็จ", "อนุมัติ", "ผ่าน"].includes(value)) {
        return "badge-success"; // เขียว
      } else if (["รอดําเนินการ", "กำลังดำเนินการ"].includes(value)) {
        return "badge-warning"; // เหลือง
      } else {
        return "badge-danger"; // แดง
      }
    },
    rowClass(item) {
      if (!item) return ''

      let rowClass = ''

      // 👉 กำหนดความสำคัญสูงสุดก่อน
      if (item.cardSerialNumber === "" || item.cardSerialNumber == null) {
        return 'table-warning'   // ว่าง → สีส้ม
      }

      // 👉 ถ้ามีค่า → เขียว
      if (item.cardSerialNumber) {
        return 'table-success'
      }

      // 👉 ถ้าอยากใช้เงื่อนไข status ต่อ
      if (item.status === 'confirmed' && (!item.actualEntryDate || item.actualEntryDate === '')) {
        return 'my-row-danger'
      } else if (item.status === 'confirmed' && item.actualEntryDate) {
        return 'my-row-success'
      } else if (item.status === 'Inactive') {
        return 'my-row-danger'
      }

      return ''
    },
    hasTime(dateString) {
      if (!dateString) return false
      // สมมติเวลาจะมี format เช่น "11/08/2025 14:42:12"
      return /\d{2}:\d{2}:\d{2}/.test(dateString)
    },
    statusText(status) {
      switch (status) {
        case 'confirmed':
          return 'อนุมัติ'
        case 'rejected':
          return 'ยกเลิก'
        case 'pending':
          return 'รอดำเนินการ'
        default:
          return status
      }
    },
    validate() {
      this.showError = !this.out_dateDefault;

      if (this.showError) {
        // หยุดการ submit
        return;
      }

      return true;
    },
    async openStatusModal(item) {
      console.log("เปิด modal สำหรับ item:", item);
      this.statusGroups = [];
      this.selectedItem = item;

      if (item.processingStatus) {
        try {
          const parsed = JSON.parse(item.processingStatus); // แปลง string → array
          if (Array.isArray(parsed) && parsed.length > 0) {
            // รวมทุก object
            this.statusGroups = parsed.flatMap(obj =>
              Object.entries(obj).map(([category, value]) => ({
                category,
                statusList: [value] // เก็บเป็น array ของ status
              }))
            );
          }
        } catch (e) {
          console.error("Error parsing processingStatus:", e);
          this.statusGroups = [];
        }
      }

      this.showModal = true;
    },
    addStatus(groupIndex) {
      this.statusGroups[groupIndex].statusList.push("");
    },
    removeStatus(groupIndex, statusIndex) {
      this.statusGroups[groupIndex].statusList.splice(statusIndex, 1);
    },
    addCategory() {
      if (this.newCategory.trim() !== "") {
        this.statusGroups.push({ category: this.newCategory.trim(), statusList: [] });
        this.newCategory = "";
      }
    },
    removeCategory(groupIndex) {
      this.statusGroups.splice(groupIndex, 1);
    },
    async UpdateStatus() {


      console.log("สร้างบัตรสำเร็จสำหรับ:", this.selectedRows)

      const _status = [
        { "ลงทะเบียน": "สำเร็จ" },
        { "จ่ายเงิน": "สำเร็จ" },
        { "สร้างบัตร": "สำเร็จ" },
      ];

      const jwt = JSON.parse(localStorage.getItem("company_jwt"));

      for (const row of this.selectedRows) {
        const _data = {
          staffId: jwt.userId,
          entryId: row.entryId, // ใช้ entryId จากแต่ละแถว
          processingStatus: JSON.stringify(_status),
        };

        console.log("Data to send:", _data);

        try {
          const res = await axios.put(`${API}entry`, _data, {
            headers: {
              Authorization: await store.dispatch("getAuthorization"),
            },
          });

          if (res.data.message === "Border entry updated successfully") {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "บันทึกข้อมูลสำเร็จทั้งหมด",
                icon: "CheckIcon",
                variant: "success",
              },
            });
          }
        } catch (error) {
          console.error("Error updating entry:", error.response);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.response?.data?.message || "เกิดข้อผิดพลาด",
              icon: "EditIcon",
              variant: "danger",
            },
          });
        }
      }
      this.showModal = false;
      return; // หยุดการทำงานที่นี่เพื่อดู log ก่อน
      // const _status = [
      //   { "ลงทะเบียน": "สำเร็จ" },
      //   { "จ่ายเงิน": "สำเร็จ" },
      //   { "สร้างบัตร": "สำเร็จ" },
      // ];
      // const jwt = JSON.parse(localStorage.getItem("company_jwt"));
      // const _data = {
      //   staffId: jwt.userId,
      //   entryId: this.selectedItem.entryId,
      //   processingStatus: JSON.stringify(_status)
      // }
      // console.log("Data to send:", _data);

      // axios
      //   .put(`${API}entry`, _data, {
      //     headers: {
      //       Authorization: await store.dispatch("getAuthorization"),
      //     },
      //   })
      //   .then(async (res) => {
      //     console.log(res);
      //     if (res.data.message == "Border entry updated successfully") {
      //       this.$swal({
      //         icon: "success",
      //         title: "อัพเดทข้อมูล!",
      //         text: "อัพเดทข้อมูลสำเร็จ",
      //         showCancelButton: false,
      //         showConfirmButton: true,
      //         timer: 1500,
      //         customClass: {
      //           confirmButton: "btn btn-success",
      //         },
      //       });
      //     }
      //   })
      //   .catch(async (error) => {
      //     console.log(error.response);
      //   });
      // // });
      // // 🔁 ส่งข้อมูลที่ถูกแก้ไขไปยัง backend หรือจัดการใน frontend
      // console.log("บันทึกข้อมูล:")

      this.showModal = false;

    },


    async saveStatus() {


      // แปลง statusGroups ให้เป็น object
      const statusObj = {};
      this.statusGroups.forEach(group => {
        // เอาค่าแรกใน statusList เป็น value
        statusObj[group.category] = group.statusList[0] || "";
      });

      // ทำให้เป็น array ตามรูปแบบที่ต้องการ
      const result_status = [statusObj];
      console.log("JSON:", JSON.stringify(result_status));

      const jwt = JSON.parse(localStorage.getItem("company_jwt"));
      const _data = {
        staffId: jwt.userId,
        entryId: this.selectedItem.entryId,
        processingStatus: JSON.stringify(result_status)
      }
      console.log("Data to send:", _data);

      axios
        .put(`${API}entry`, _data, {
          headers: {
            Authorization: await store.dispatch("getAuthorization"),
          },
        })
        .then(async (res) => {
          console.log(res);
          if (res.data.message == "Border entry updated successfully") {
            this.$swal({
              icon: "success",
              title: "อัพเดทข้อมูล!",
              text: "อัพเดทข้อมูลสำเร็จ",
              showCancelButton: false,
              showConfirmButton: true,
              timer: 1500,
              customClass: {
                confirmButton: "btn btn-success",
              },
            });
          }
        })
        .catch(async (error) => {
          console.log(error.response);
        });
      // });
      // 🔁 ส่งข้อมูลที่ถูกแก้ไขไปยัง backend หรือจัดการใน frontend
      console.log("บันทึกข้อมูล:")

      this.showModal = false;

    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      console.log(filteredItems);
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async saveAsImage(item) {
      const element = document.getElementById("element-id-to-capture");
      if (!element) {
        console.error("Element to capture not found");
        return;
      }

      try {
        const canvas = await html2canvas(element);
        const dataUrl = canvas.toDataURL("image/png");

        const link = document.createElement("a");
        link.href = dataUrl;
        link.download = `Queue_${item.IdCode}.png`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error("Error capturing element as image:", error);
      }
    },
    // async createImageAndSave(item) {
    //   // ขนาดบัตร NFC แนวตั้ง (scale 4px/mm)
    //   const canvas = document.createElement("canvas");
    //   canvas.width = 216;  // กว้าง
    //   canvas.height = 342; // สูง
    //   const ctx = canvas.getContext("2d");

    //   // พื้นหลังขาว
    //   ctx.fillStyle = "#fff";
    //   ctx.fillRect(0, 0, canvas.width, canvas.height);

    //   // เส้นขอบ
    //   ctx.strokeStyle = "#000";
    //   ctx.lineWidth = 2;
    //   ctx.strokeRect(0, 0, canvas.width, canvas.height);

    //   // ข้อความ
    //   // ข้อความ
    //   ctx.fillStyle = "#000";
    //   ctx.font = "12px Arial";
    //   ctx.textAlign = "center";   // จัดกึ่งกลางแนวนอน
    //   ctx.textBaseline = "top";   // ใช้ top เพื่อเลื่อนแต่ละบรรทัดได้ง่าย

    //   let centerX = canvas.width / 2;
    //   ctx.fillText(`${item.prefix} ${item.firstname} ${item.lastname}`, centerX, 30);
    //   ctx.fillText(`ID: ${item.IdCode}`, centerX, 50);
    //   ctx.fillText(`Sex: ${item.gender}`, centerX, 70);
    //   ctx.fillText(`Nationality: ${item.Nationality}`, centerX, 90);
    //   // ctx.fillStyle = "#000";
    //   // ctx.font = "12px Arial";
    //   // ctx.fillText(`${item.prefix} ${item.firstname} ${item.lastname}`, 10, 30);
    //   // ctx.fillText(`ID: ${item.IdCode}`, 10, 50);
    //   // ctx.fillText(`Sex: ${item.gender}`, 10, 70);
    //   // ctx.fillText(`Nationality: ${item.Nationality}`, 10, 90);
    //   // ฟังก์ชันสร้าง QR
    //   function getQrImage(url) {
    //     return new Promise((resolve, reject) => {
    //       QRCode.toDataURL(url, function (err, qrUrl) {
    //         if (err) reject(err);
    //         else {
    //           const img = new Image();
    //           img.onload = () => resolve(img);
    //           img.onerror = reject;
    //           img.src = qrUrl;
    //         }
    //       });
    //     });
    //   }

    //   try {
    //     const { VUE_APP_FONTEND_URL } = process.env;
    //     const qrUrl = `${VUE_APP_FONTEND_URL}booking?prm1=${item.IdCode}&prm2=${item.createdAtFormatted_img.replace(/-/g, '')}`;
    //     const img = await getQrImage(qrUrl);

    //     // วาง QR ด้านล่างตรงกลาง
    //     const qrSize = 200;
    //     const qrX = (canvas.width - qrSize) / 2;
    //     const qrY = canvas.height - qrSize - 20;
    //     ctx.drawImage(img, qrX, qrY, qrSize, qrSize);

    //     // เซฟไฟล์
    //     const link = document.createElement("a");
    //     link.href = canvas.toDataURL("image/png");
    //     link.download = `QR_${item.IdCode}.png`;
    //     link.click();
    //   } catch (error) {
    //     console.error("Error creating QR Code image:", error);
    //   }
    // },
    async createImageAndSave(item) {

      // ==== ขนาดก่อน scale ====
      const W = 342;
      const H = 216;

      const canvas = document.createElement("canvas");
      canvas.width = W * 2;        // 2x resolution
      canvas.height = H * 2;

      const ctx = canvas.getContext("2d");
      ctx.scale(2, 2);             // ทุกสิ่งที่วาดใช้ W,H ตามจริง

      // ==== พื้นหลัง ====
      ctx.fillStyle = "#e6ffe4";
      ctx.fillRect(0, 0, W, H);

      // ==== Header ====
      const headerHeight = 40;
      ctx.fillStyle = "rgb(255,132,132)";
      ctx.fillRect(0, 0, W, headerHeight);

      // ---- ข้อความ header ----
      const headerText = "Myanmar Labor Registration Card";
      ctx.font = "bold 14px Arial";
      const textWidth = ctx.measureText(headerText).width;

      const centerX = W / 2;
      const centerY = headerHeight / 2;

      // โหลดธง
      const flagLeft = new Image();
      const flagRight = new Image();
      flagLeft.src = flagSrcL;
      flagRight.src = flagSrcR;

      await Promise.all([
        new Promise(r => flagLeft.onload = r),
        new Promise(r => flagRight.onload = r)
      ]);

      const flagWidth = 50;
      const flagHeight = 30;

      // ชิดขอบจริง
      const paddingFlag = 0;

      const leftFlagX = paddingFlag;
      const rightFlagX = W - flagWidth - paddingFlag;

      const flagY = centerY - flagHeight / 2;

      // วาดธง
      ctx.drawImage(flagLeft, leftFlagX, flagY, flagWidth, flagHeight);
      ctx.drawImage(flagRight, rightFlagX, flagY, flagWidth, flagHeight);

      ctx.fillStyle = "#000";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillText(headerText, centerX, centerY);

      // ==== เนื้อหา ====
      ctx.fillStyle = "#000";
      ctx.font = "14px Arial";
      ctx.textAlign = "left";
      ctx.textBaseline = "top";

      const normalFont = "14px Arial";
      const boldFont = "bold 14px Arial";
      const marginLeft = 15;
      let startY = 70;
      const lineHeight = 20;

      // functions helper...
      function drawLabelValue(label, value) {
        ctx.font = normalFont;
        ctx.fillText(label, marginLeft, startY);
        const w = ctx.measureText(label).width;
        ctx.font = boldFont;
        ctx.fillText(value, marginLeft + w, startY);
        startY += lineHeight;
      }

      drawLabelValue("ID number  ", `${item.IdCode}`);
      drawLabelValue("Name surname  ", `${item.prefix} ${item.firstname} ${item.lastname}`);
      drawLabelValue("Nationality  ", `${item.nationality}`);

      const genderText = item.gender === "M" ? "Male" : item.gender === "F" ? "Female" : item.gender;
      drawLabelValue("Sex  ", genderText);

      drawLabelValue("Birth date  ", `${this.formUser.Birthdate}`);
      drawLabelValue("Issuer date  ", `${this.formUser.Issuerdate}`);
      drawLabelValue("Expired date  ", `${this.formUser.Expireddate}`);

      // ==== QR Hi-Res Generator ====
      function getHighResQr(url, scale = 6) {
        return new Promise((resolve, reject) => {
          QRCode.toDataURL(url, {
            scale: scale,
            margin: 1,
            errorCorrectionLevel: "H",
          }, (err, dataUrl) => {
            if (err) return reject(err);
            const img = new Image();
            img.onload = () => resolve(img);
            img.onerror = reject;
            img.src = dataUrl;
          });
        });
      }

      try {
        // --- สร้าง URL ---
        const today = new Date();
        const d = String(today.getDate()).padStart(2, "0");
        const m = String(today.getMonth() + 1).padStart(2, "0");
        const y = today.getFullYear();

        const { VUE_APP_FONTEND_URL } = process.env;
        const qrUrl = `${VUE_APP_FONTEND_URL}booking?prm1=${item.IdCode}&prm2=${y + m + d}`;

        // --- โหลด QR ความละเอียดสูง ---
        const qrHigh = await getHighResQr(qrUrl, 8); // scale 8 คมมากที่สุด (ลอง 6–10)

        // ==== ตำแหน่ง QR (ใช้ W,H ไม่ใช่ canvas.width) ====
        const qrSize = 60;       // ขนาดแสดงจริง
        const padding = 15;      // ระยะห่างขอบ

        const qrX = W - qrSize - padding;
        const qrY = H - qrSize - padding;

        ctx.drawImage(qrHigh, qrX, qrY, qrSize, qrSize);

        // ดาวน์โหลดไฟล์
        const link = document.createElement("a");
        link.href = canvas.toDataURL("image/png", 0.92);
        link.download = `QR_${item.IdCode}.png`;
        link.click();

      } catch (err) {
        console.error("QR Error:", err);
      }
    }
    ,

    async handlePrint(item) {
      console.log("พิมพ์ข้อมูล:", item);

      // 🆕 กำหนดขนาดกระดาษเป็นขนาดบัตรพนักงาน (85.6mm x 54mm)
      const doc = new jsPDF({
        orientation: "landscape", // แนวนอน
        unit: "mm",
        format: [85.6, 54] // ขนาดบัตร
      });

      doc.setFontSize(10);

      const data = [
        ["Name", `${item.prefix} ${item.firstname} ${item.lastname}`],
        ["ID Card No.", item.IdCode],
        ["Sex", item.gender],
        ["Nationality", item.Nationality],
        // ["Appointment Date", item.registeredExitDateFormatted],
        // ["Card SerialNumber", item.cardSerialNumber],
      ];

      autoTable(doc, {
        startY: 5,
        body: data,
        styles: { fontSize: 7, cellPadding: 0.5 },
        margin: { left: 2, right: 2 }
      });

      const { VUE_APP_FONTEND_URL } = process.env;
      const url = `${VUE_APP_FONTEND_URL}booking?IdCode=${item.IdCode}&createdAt=${item.createdAtFormatted_img.replace(/-/g, '')}`;
      console.log("QR Code URL:", url);

      try {
        const qrDataUrl = await QRCode.toDataURL(url);
        const qrSize = 15; // เล็กลงให้พอดีกับบัตร
        const qrX = (85.6 - qrSize) / 2;
        const qrY = 30;
        doc.addImage(qrDataUrl, "PNG", qrX, qrY, qrSize, qrSize);
        doc.setFontSize(6);
        doc.text(`IdCode: ${item.IdCode}`, 85.6 / 2, qrY + qrSize + 5, { align: "center" });
      } catch (err) {
        console.error("❌ QR Code Error:", err);
      }

      doc.save(`Queue_${item.IdCode}.pdf`);
    }
    , async getDatauserFromCompany(_userId) {
      try {
        const jwt = JSON.parse(localStorage.getItem("company_jwt"));
        const params = {
          companyId: jwt.companyId,
          userId: _userId,
        };
        // console.log("Request Params", params);
        const res = await axios.get(`${API}userFromCompany`, {
          params,
          headers: {
            Authorization: await store.dispatch("getAuthorization"),
          },
        });
        // console.log("API Response", res.data)
        return res.data.message.data;
      } catch (err) {
        console.error("❌ Error:", err.response?.data || err.message);
      } finally {
        this.isBusy = false;
      }

      return;

    },
    formatDateFromYYYYMMDD(dateStr) {
      if (!dateStr || dateStr.length !== 8) return "";
      const year = dateStr.substring(0, 4);
      const month = dateStr.substring(4, 6);
      const day = dateStr.substring(6, 8);
      return `${day}/${month}/${year}`;
    },
    formatDateFromYYYYMMDD_pdf(dateStr) {
      if (!dateStr || dateStr.length !== 8) return "";
      const year = dateStr.substring(0, 4);
      const month = dateStr.substring(4, 6);
      const day = dateStr.substring(6, 8);
      return `${year}/${month}/${day}`;
    },
    editItem(item) {
      this.editUser = { ...item }; // clone item
      this.showEditModal = true;
      // เพิ่ม logic แก้ไข
      console.log("Edit item:", this.editUser);
      console.log(this.options);
      if (!this.editUser.BorderCheckpoint && this.editUser.stationName) {
        this.editUser.BorderCheckpoint = this.editUser.stationName;
      }
      this.editUser.DateooutThailand = this.editUser.registeredExitDateFormatted
        ? new Date(this.editUser.registeredExitDateFormatted.split("/").reverse().join("/"))
        : null;
      this.editUser.DateinThailand = this.editUser.registeredEntryDateFormatted
        ? new Date(this.editUser.registeredEntryDateFormatted.split("/").reverse().join("/"))
        : null;

      // คำนวณจำนวนคิวที่เหลือ
      this.count_data = 0;
      if (this.editUser.BorderCheckpoint) {
        const borderData = this.items.filter(item => item.BorderCheckpoint === this.editUser.BorderCheckpoint);
        this.count_data = borderData.length;
      }
      console.log("Count data:", this.count_data);
      this.editUser.Round = this.editUser.shift || "รอบเช้า"; // กำหนดค่าเริ่มต้นถ้าไม่มี
    },
    formatToYYYYMMDD(dateInput) {
      let parsedDate;

      // 1. ถ้า dateInput เป็น Date object หรือ ISO string
      if (dateInput instanceof Date || /\d{4}-\d{2}-\d{2}T/.test(dateInput)) {
        parsedDate = dayjs(dateInput);
      } else if (/^\d{2}-\d{2}-\d{4}$/.test(dateInput)) {
        // 2. ถ้าเป็น string รูปแบบ DD-MM-YYYY หรือ MM-DD-YYYY
        // เราจะพยายาม parse แบบ DD-MM-YYYY ก่อน
        parsedDate = dayjs(dateInput, "DD-MM-YYYY", true);
        if (!parsedDate.isValid()) {
          parsedDate = dayjs(dateInput, "MM-DD-YYYY", true);
        }
      } else {
        // กรณีอื่น ๆ
        parsedDate = dayjs(dateInput);
      }

      if (!parsedDate.isValid()) {
        console.error("วันที่ไม่ถูกต้อง:", dateInput);
        return null;
      }

      return parsedDate.format("YYYYMMDD");
    },
    async saveEdit() {



      const { username, password, firstname, lastname } = this.formUser;
      const jwt = JSON.parse(localStorage.getItem("company_jwt"));
      //   console.log(jwt);
      console.log(this.editUser);
      // const res_data = this.items.map(async item => {

      const _data = {
        staffId: jwt.userId,
        entryId: this.editUser.entryId,
        stationName: this.editUser.BorderCheckpoint,
        shift: this.editUser.Round,
        registeredExitDate: this.formatToYYYYMMDD(this.editUser.registeredExitDate),
        registeredEntryDate: this.formatToYYYYMMDD(this.editUser.registeredEntryDate),
      }
      console.log("Data to send:", _data);

      axios
        .put(`${API}entry`, _data, {
          headers: {
            Authorization: await store.dispatch("getAuthorization"),
          },
        })
        .then(async (res) => {
          console.log(res);
          if (res.data.message == "Border entry updated successfully") {
            this.$swal({
              icon: "success",
              title: "อัพเดทข้อมูล!",
              text: "อัพเดทข้อมูลสำเร็จ",
              showCancelButton: false,
              showConfirmButton: true,
              timer: 1500,
              customClass: {
                confirmButton: "btn btn-success",
              },
            });
          }
        })
        .catch(async (error) => {
          console.log(error.response);
        });
      // });
      // 🔁 ส่งข้อมูลที่ถูกแก้ไขไปยัง backend หรือจัดการใน frontend
      console.log("บันทึกข้อมูล:", this.editUser);
      this.showEditModal = false;
      this.showError = false;
    },
    async Getdata() {
      // ตัวอย่างดึงข้อมูลจาก store (หรือ API)
      console.log(this.startDate);
      this.isLoading = true;

      try {
        const jwt = JSON.parse(localStorage.getItem("company_jwt"));
        const formatDate = (dateObj) => {
          if (typeof dateObj === 'string') {
            dateObj = new Date(dateObj);
          }
          if (!(dateObj instanceof Date) || isNaN(dateObj)) return "";
          const day = String(dateObj.getDate()).padStart(2, "0");
          const month = String(dateObj.getMonth() + 1).padStart(2, "0");
          const year = String(dateObj.getFullYear());
          return `${day}-${month}-${year}`;
        };

        const startStr = formatDate(new Date(this.startDate));
        const endStr = formatDate(new Date(this.endDate));


        const [dayExit, monthExit, yearExit] = startStr.split("-");
        const [dayEntry, monthEntry, yearEntry] = endStr.split("-");

        let params = {
          userId: jwt.userId,
          includeCompany: 'true',
          startDate: `${yearExit}${monthExit}${dayExit}`,
          endDate: `${yearEntry}${monthEntry}${dayEntry}`,
          emptyStationName: 'true',
          _page: this.currentPage,
          _limit: this.perPage,
          _sort: "-1",
        };

        if (this.formUser.IdCode && this.formUser.IdCode.trim() !== "") {
          params.IdCode = this.formUser.IdCode;
        }
        if (this.selectedBorder && this.selectedBorder.trim() !== "") {
          params.stationName = this.selectedBorder;
        }
        console.log("Request Params", params);

        const res = await axios.get(`${API}entry`, {
          params,
          headers: {
            Authorization: await store.dispatch("getAuthorization"),
          },
        });
        console.log("API Response", res.data.message.data);


        if (!res.data.message.data || !res.data.message.total) {
          this.items = [];
          this.totalRows = 0;
          return;
        }

        const results = await Promise.all(
          res.data.message.data.map(async (item, index) => {
            console.log(item.registeredExitDate)
            const date = new Date(item.createdAt);
            console.log(date)
            const formattedDate = `${String(date.getDate()).padStart(2, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}-${date.getFullYear()}`;
            var sp = item.createdAt.split(' ')// `${date.getFullYear()}-${String(date.getDate()).padStart(2, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}`;
            var createdAtFormatted_img = sp[0].split('/')
            // console.log("Item UserId:", item.userId);
            const datausername = await this.getDatauserFromCompany(item.userId); // <- เรียก async ได้
            //   console.log(createdAtFormatted_img);
            return {
              ...item,
              no: index + 1,
              createdAtFormatted: createdAtFormatted_img[0] + '/' + createdAtFormatted_img[1] + '/' + createdAtFormatted_img[2],//item.createdAt,
              nationality: datausername ? datausername.nationality : '',
              shift: item.shift ? item.shift : '',
              registeredExitDateFormatted: this.formatDateFromYYYYMMDD(item.registeredExitDate),
              registeredEntryDateFormatted: this.formatDateFromYYYYMMDD(item.registeredEntryDate),
              formatDateFromYYYYMMDD_pdf: this.formatDateFromYYYYMMDD_pdf(item.registeredExitDate),
              createdAtFormatted_img: createdAtFormatted_img[2] + createdAtFormatted_img[1] + createdAtFormatted_img[0],
              registeredExitDate: dayjs(item.registeredExitDate).format("DD/MM/YYYY"),//item.registeredExitDate,
              registeredEntryDate: dayjs(item.registeredEntryDate).format("DD/MM/YYYY"),// item.registeredEntryDate,
              _selected: false,
              // datausername, // <- ใส่ข้อมูลที่ได้จาก async ไปใน object
              cardSerialNumber: datausername ? datausername.cardSerialNumber : '',
              prefix: datausername ? datausername.prefix : '',
              firstname: datausername ? datausername.firstname : '',
              lastname: datausername ? datausername.lastname : '',
              gender: datausername ? datausername.gender : '',
              actualEntryDate: await this.convertDate(item.actualEntryDate), ///เข้ามาจริง
              actualExitDate: await this.convertDate(item.actualExitDate) // ออกจริง

            };
          })
        );
        // const results = res.data.message.data.map((item, index) => {
        //   const date = new Date(item.createdAt);
        //   const formattedDate = `${String(date.getDate()).padStart(2, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}-${date.getFullYear()}`;
        //   // const datausername = await getDatauserFromCompany()
        //   return {
        //     ...item,
        //     no: index + 1, // ลำดับเริ่มที่ 1
        //     createdAtFormatted: formattedDate,
        //     _selected: false, // เพิ่มให้ทุกแถวมี property นี้
        //   };
        // });

        console.log(results);
        // mapall

        this.items = results;

        this.totalRows = res.data.message.total;
      } catch (err) {
        console.error("❌ Error:", err.response?.data || err.message);
      } finally {
        this.isBusy = false;
        this.isLoading = false;

      }
      return;
    },
    async convertDate(dateStr) {
      // สมมติ dateStr format: "dd/MM/yyyy HH:mm:ss"
      const [datePart] = dateStr.split(' ') // แยกเอาแค่วันที่
      const [dd, MM, yyyy] = datePart.split('/')
      if (!datePart) return ''

      // คืนค่าแบบ MM-dd-yyyy
      return `${MM}-${dd}-${yyyy}`
    },
    async getDataSelectOption() {
      const jwt = JSON.parse(localStorage.getItem("company_jwt"));
      try {
        const res = await axios.get(`${API}config?userId=${jwt.userId}&configType=station`,
          {
            headers: {
              Authorization: await store.dispatch("getAuthorization"),
            },
          });
        console.log("✅ success");
        const responseData = res.data.message.data;

        // แปลงข้อมูลให้ตรงกับรูปแบบ dropdown
        const dynamicOptions = responseData.map((item) => ({
          value: item.stationName, // สมมติ field ชื่อ borderName
          text: item.stationName,
        }));

        // รวม option แรก + ตัวเลือกจาก API
        this.options = [{ value: null, text: "-- เลือกด่านชายแดน --" }, ...dynamicOptions];
      } catch (err) {
        if (err.response) {
          console.error("❌ API Error:", err.response.status);
          console.error("Response:", err.response.data);
        } else {
          console.error("❌ Error:", err.message);
        }
      }
    },

    async getDataTable() {

      const dd = await store.getters.getChang;
      //   const dd = await this.$store.dispatch("data_addqueue");
      console.log(dd);
      if (!dd || !dd.length) {
        // console.error("No data available");
        this.itemsdata = [];
        this.totalRows = 0;
        return;
      }
      this.items = dd[0];
      this.itemsdata = dd[0];
      this.totalRows = dd[0].length;
      return


      this.isBusy = true;
      try {
        const jwt = JSON.parse(localStorage.getItem("company_jwt"));

        const params = {
          companyId: jwt.companyId,
          userIdRule: jwt.userId,
          startDate: "2024-07-01",
          endDate: "2025-07-21",
          _page: this.currentPage,
          _limit: this.perPage,
          _sort: "-1",
        };

        const res = await axios.get(`${API}SearchLog`, {
          params,
          headers: {
            Authorization: await store.dispatch("getAuthorization"),
          },
        });

        console.log("API Response", res.data.message);
        console.log("API Response totalRows", res.data.message.total);
        this.itemsdata = res.data.message.data;
        this.totalRows = res.data.message.total;
      } catch (err) {
        console.error("❌ Error:", err.response?.data || err.message);
      } finally {
        this.isBusy = false;
      }
    },
    async handlePageChange(page) {
      console.log(page);
      this.currentPage = page;
      this.items = [];

      await this.Getdata();
    },
    async handleItemsPerPageChange() {
      this.items = [];
      this.currentPage = 1;
      await this.Getdata();
    },
  },
};
</script>
<style>
.my-row-success {
  background-color: #28a745 !important;
  /* สีเขียว */
  color: white !important;
}

.my-row-danger {
  background-color: #dc3545 !important;
  /* สีแดง */
  color: white !important;
}
</style>